// Našeptávač „Měli jste na mysli…?" pro překlepy v doméně e-mailu.
// Event delegace na document — přežije překreslení naja snippetů.

const COMMON_DOMAINS = [
	'seznam.cz',
	'gmail.com',
	'email.cz',
	'centrum.cz',
	'atlas.cz',
	'volny.cz',
	'post.cz',
	'tiscali.cz',
	'outlook.com',
	'hotmail.com',
	'icloud.com',
	'azet.sk',
	'centrum.sk',
	'post.sk',
	'atlas.sk',
];

const MAX_DISTANCE = 2;
const HINT_CLASS = 'email-suggest-hint';

const damerauLevenshtein = (a, b) => {
	const d = Array.from({ length: a.length + 1 }, () =>
		new Array(b.length + 1).fill(0),
	);
	for (let i = 0; i <= a.length; i += 1) d[i][0] = i;
	for (let j = 0; j <= b.length; j += 1) d[0][j] = j;

	for (let i = 1; i <= a.length; i += 1) {
		for (let j = 1; j <= b.length; j += 1) {
			const cost = a[i - 1] === b[j - 1] ? 0 : 1;
			d[i][j] = Math.min(
				d[i - 1][j] + 1,
				d[i][j - 1] + 1,
				d[i - 1][j - 1] + cost,
			);
			if (
				i > 1 &&
				j > 1 &&
				a[i - 1] === b[j - 2] &&
				a[i - 2] === b[j - 1]
			) {
				d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
			}
		}
	}

	return d[a.length][b.length];
};

const domainLabel = domain => {
	const dotIndex = domain.indexOf('.');
	return dotIndex === -1 ? domain : domain.slice(0, dotIndex);
};

const domainTld = domain => {
	const dotIndex = domain.indexOf('.');
	return dotIndex === -1 ? '' : domain.slice(dotIndex + 1);
};

const suggestDomain = domain => {
	if (COMMON_DOMAINS.includes(domain)) {
		return null;
	}

	// Jméno poskytovatele a koncovka se porovnávají zvlášť a jméno má přednost.
	// Na vzdálenosti přes celou doménu by dvojitý překlep jako gmial.cz
	// (prohozená písmena + špatná koncovka) vyhrál textově bližší email.cz —
	// úplně jiný reálný poskytovatel.
	const label = domainLabel(domain);
	const tld = domainTld(domain);

	let best = null;
	let bestLabelDistance = MAX_DISTANCE + 1;
	let bestTldDistance = MAX_DISTANCE + 1;
	COMMON_DOMAINS.forEach(candidate => {
		const labelDistance = damerauLevenshtein(label, domainLabel(candidate));
		const tldDistance = damerauLevenshtein(tld, domainTld(candidate));
		if (labelDistance > MAX_DISTANCE || tldDistance > MAX_DISTANCE) {
			return;
		}
		if (
			labelDistance < bestLabelDistance ||
			(labelDistance === bestLabelDistance &&
				tldDistance < bestTldDistance)
		) {
			best = candidate;
			bestLabelDistance = labelDistance;
			bestTldDistance = tldDistance;
		}
	});

	return best;
};

const removeHint = input => {
	const hint = input.parentNode?.querySelector(`.${HINT_CLASS}`);
	if (hint) {
		hint.remove();
	}
};

const showHint = (input, suggestion) => {
	// Mousedown na odkaz vyvolá focusout ještě před kliknutím — pokud by se
	// hint pro stejný návrh překreslil, klik na odkaz by se ztratil.
	const existing = input.parentNode?.querySelector(`.${HINT_CLASS}`);
	if (existing && existing.dataset.suggestion === suggestion) {
		return;
	}

	removeHint(input);

	const hint = document.createElement('p');
	hint.className = HINT_CLASS;
	hint.dataset.suggestion = suggestion;
	hint.innerHTML =
		'Měli jste na mysli <a href="#" class="email-suggest-apply"><strong></strong></a>?';
	hint.querySelector('strong').textContent = suggestion;
	hint.querySelector('a').addEventListener('click', event => {
		event.preventDefault();
		input.value = suggestion;
		removeHint(input);
	});
	input.insertAdjacentElement('afterend', hint);
};

document.addEventListener('focusout', event => {
	const input = event.target;
	if (!(input instanceof HTMLInputElement) || input.name !== 'email') {
		return;
	}

	const value = input.value.trim();
	const atPosition = value.lastIndexOf('@');
	if (atPosition === -1) {
		removeHint(input);
		return;
	}

	const local = value.slice(0, atPosition);
	const domain = value.slice(atPosition + 1).toLowerCase();
	const suggestion = domain.length > 2 ? suggestDomain(domain) : null;

	if (suggestion) {
		showHint(input, `${local}@${suggestion}`);
	} else {
		removeHint(input);
	}
});
